<template>
  <v-card flat>
    <v-form ref="form" v-model="form.valid">
      <div v-if="mode=='free'" style="margin-bottom:10px;">
        <v-flex xs12 class="formElementLabel">食べた食品の名前</v-flex>
        <v-flex xs12>
          <v-text-field 
            outline
            v-model="form_free.name"
            :rules="[rules.required, rules.max50]"
            placeholder="例：蒙古タンメン"></v-text-field>
        </v-flex>
      </div>
      <v-flex xs12 class="formElementLabel">感想・コメントなど（必須入力）</v-flex>
      <v-flex xs12>
        <v-textarea
          outline
          v-model="form.content"
          :rules="[rules.required, rules.max500]"
          placeholder="食品を食べた感想や、味の評価などご自由に記入ください！" style="padding-top:0;" rows="10"
        ></v-textarea>
      </v-flex>
      <!-- 画像エリア-->
      <v-flex xs12 class="formElementLabel">画像</v-flex>
      <v-layout row wrap class="formBlock">
        <input type="file" style="display: none;" ref="image" v-on:change="onFileChange" mulitple="multiple">
        <v-layout v-if="imageURI.length>0" row wrap>
          <v-flex xs4 md4 v-for="(image, id) in imageURI" :key=id>
            <p style="text-align:right;position:absolute;width:30%;max-width:150px;">
              <v-btn fab small color="white" @click="clearImage(id)">
                <v-icon>clear</v-icon>
              </v-btn>
            </p>
            <img :src="image" style="max-width:90%;max-heght:300px;">
          </v-flex>
        </v-layout>
        <v-flex xs12>
          <v-btn @click="pickImage()" round outline block color="primary">
            <v-icon>photo</v-icon>&nbsp;画像を追加する
          </v-btn>
        </v-flex>
      </v-layout>
      <!-- /画像エリア-->
      <!-- 関連URL -->
      <div class="formBlock" style="margin-bottom:4px !important;">
        <v-layout row wrap>
          <v-flex xs6 class="formElementLabel" style="padding-top:5px;">関連URL・リンク
            <v-tooltip top color="green" close-delay="2000">
            <template  v-slot:activator="{ on }">
              <v-btn small icon v-on="on"><v-icon color="red">info</v-icon></v-btn>
            </template>
            <span>リンクURLを記入ください<br>Youtube、Twitterの場合、カラログに埋め込まれます。</span>
          </v-tooltip>
          </v-flex>
        </v-layout>
        <v-flex xs12>
          <v-text-field
            outline
            v-model="form.referURL"
            :rules="[rules.max500]"
            placeholder="https://karaimono-tabetai.jp" style="padding-top:0;" rows="2"
          ></v-text-field>
        </v-flex>
      </div>
      <!-- /購入場所 -->

      <!-- Rating -->
      <div class="formBlock" style="position:relative">
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs6 class="formElementLabel" style="padding-top:5px;">満足度</v-flex>
            <v-flex xs6 style="text-align:right;">
              <v-chip v-show="isRating" @click="isRating=!isRating" small color="pink lighten-5" class="primary--text">ON<v-icon right small style="margin-left:7px">fiber_manual_record</v-icon></v-chip>
              <v-chip v-show="!isRating" @click="isRating=!isRating" small color="grey lighten-3" class="grey--text"><v-icon left small style="margin-right:2px">fiber_manual_record</v-icon>OFF</v-chip>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-layout row wrap>
          <v-spacer></v-spacer>
          <v-flex xs3 style="padding-top:8px;text-align:left;">辛さ</v-flex>
          <v-flex xs9 md5 style="text-align:left;">
            <v-rating v-model="rating.hot" :readonly="!isRating" :color="isRating ? 'red' : 'grey'" :background-color="isRating ? 'red' : 'grey'">
            </v-rating>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
        <v-layout row wrap>
          <v-spacer></v-spacer>
          <v-flex xs3 style="padding-top:8px;text-align:left;">味・美味しさ</v-flex>
          <v-flex xs9 md5 style="text-align:left;">
            <v-rating v-model="rating.taste" :readonly="!isRating" :color="isRating ? 'orange' : 'grey'" :background-color="isRating ? 'orange' : 'grey'"></v-rating></v-flex>
          <v-spacer></v-spacer>
        </v-layout>
        <div v-show="!isRating" style="position: absolute; top:40px;width:100%">
          <div style="background: rgba(0, 0, 0, 0.3);width:100%;padding:10px 0;">
            <v-btn @click="isRating=!isRating" color="white" class="primary--text">満足度を登録する</v-btn>
          </div>
        </div>
      </div>
      <!-- /Rating -->
      <!-- 購入場所 -->
      <div class="formBlock" style="position: relative">
        <v-layout row wrap>
          <v-flex xs6 class="formElementLabel" style="padding-top:5px;">購入場所・食べた場所</v-flex>
          <v-flex xs6 style="text-align:right;">
            <v-chip v-show="isPlace" @click="isPlace=!isPlace" small color="pink lighten-5" class="primary--text">ON<v-icon right small style="margin-left:7px">fiber_manual_record</v-icon></v-chip>
            <v-chip v-show="!isPlace" @click="isPlace=!isPlace" small color="grey lighten-3" class="grey--text"><v-icon left small style="margin-right:2px">fiber_manual_record</v-icon>OFF</v-chip>
          </v-flex>
        </v-layout>
        <v-flex xs12>
          <v-textarea
            outline
            v-model="form.place"
            :rules="[rules.max500]"
            placeholder="例：蒲田のファミマ、中本目黒店" style="padding-top:0;" rows="2"
          ></v-textarea>
        </v-flex>
        <div v-show="!isPlace" style="position: absolute; top:30px;width:100%">
          <div style="background: rgba(0, 0, 0, 0.3);width:100%;padding:10px 0;">
            <v-btn @click="isPlace=!isPlace" color="white" class="primary--text">場所情報を登録する</v-btn>
          </div>
        </div>
      </div>
      <!-- /購入場所 -->
      <v-flex xs12 style="margin-top:24px;">
        <v-btn block dark large color="primary" @click="sendForm">
          <div v-if="isLoading">
              <v-progress-circular
                indeterminate
                color="white"
              ></v-progress-circular>
            </div>
            <span v-else>カラログを投稿する</span>
        </v-btn>
      </v-flex>
    </v-form>
  </v-card>
</template>

<script>
import { db, storageRef } from '@/main'
import { getBase64Strings } from 'exif-rotate-js/lib'
import imageResize from '@/assets/js/imageResize.js'
import getImageUrl from '@/assets/js/getImageUrl.js'
var fileExtensions = ['jpg', 'jpeg', 'png', 'bmp', 'gif']
const maxSize = 600
// @ is an alias to /src
export default {
  name: 'ReviewForm',
  props: {
    mode: {
      type: String,
      default: 'food'
    },
    postData: Object,
    postId: String
  },
  data () {
    return {
      isLoading: false,
      id: '',
      form: {
        content: '',
        place: '',
        referURL: '',
        images: [],
        valid: false
      },
      form_free: {
        name: ''
      },
      rating: {
        hot: 3,
        taste: 3
      },
      imageData: [],
      imageURI: [],
      imageUploadedCounter: 0,
      rules: {
        required: v => !!v || '必須項目です。',
        max50: v => {
          return v.length <= 50 || '入力できるのは50文字までです。'
        },
        max500: v => {
          return v.length <= 500 || '入力できるのは500文字までです。'
        }
      },
      isRating: true,
      isPlace: true,
      karalogTarget: {
        isChange: false,
        type: ''
      }
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    foodId () {
      return this.$store.state.temp.id
    },
    food () {
      return this.$store.state.temp.foodData
    },
    isRatingLabel () {
      if (this.isRating) return 'ON'
      return 'OFF'
    }
  },
  created () {
    if (this.mode === 'free') {
      this.form_free.name = this.$route.query.maybe
    } else if (this.mode === 'noFood') {
      this.isRating = false
      this.isPlace = false
    } else if (this.mode === 'edit') {
      this.initEdit()
    }
  },
  methods: {
    async sendFoodData () {
      // 食品を指定していない場合、食品を登録する
      let timestamp = new Date()
      let food = {
        name: this.form_free.name,
        type: this.mode,
        user: {
          uid: this.user.uid,
          displayName: this.user.displayName,
          imageurl: this.user.imageurl
        },
        timestamp: timestamp,
        postCount: 0,
        tabetaiCount: 0,
        famousScore: 0
      }

      let images = []
      for (let i = 0; i < this.imageData.length; i++) {
        images.push(`${i}.png`)
      }
      food.images = images

      let result = await db.collection('food').add(food)
      this.$store.commit('setTempId', result.id)
      food.id = result.id
      this.$store.commit('setTempFoodData', food)

      let imageCounter = this.UnUploadImageCount(this.imageData)
      if (imageCounter > 0) {
        // this.$store.commit('setTempImages', this.imageURI)
        // var storageRef = storage.ref()
        let imageurls = []
        for (let i = 0; i < this.imageData.length; i++) {
          let imageRef = storageRef.child(`food/${food.id}/${food.images[i]}`)
          await imageRef.put(this.imageData[i])
          imageurls.push(getImageUrl.get('food', food.id, food.images[i]))
        }
        this.$store.commit('setTempImages', imageurls)
      }
    },
    async sendShopData () {
      // shop未登録の場合、ショップ情報を登録
      let timestamp = new Date()
      let address = this.food.formatted_address
      address = address.replace('日本、', '')
      let shop = {
        basic: {
          name: this.food.name,
          name_kana: '',
          address: address,
          area: {l: '', m: '', s: ''},
          lat: this.food.geometry.location.lat,
          lng: this.food.geometry.location.lng,
          imageurl: '',
          open: '',
          tel: '',
          url: ''
        },
        provider: {
          name: 'karaiine_user',
          user: this.user
        },
        system: {
          ID: {
            gnavi: '',
            hotpepper: '',
            placeID: this.food.place_id
          },
          powerdBy: '',
          timestamp: {
            entry: timestamp,
            update: timestamp
          }
        }
      }
      let result = await db.collection('shops').add(shop)
      this.$store.commit('setTempId', result.id)
      this.$store.commit('setTempFoodData', shop)
    },
    async sendForm () {
      this.imageUploadedCounter = 0
      if (this.isLoading) return

      this.$refs.form.validate()
      if (!this.form.valid) {
        let obj = {
          group: 'messageBottom',
          type: 'warning',
          title: '入力エラー',
          text: '各項目のエラーメッセージを確認して修正をお願いします。'
        }
        this.$emit('onMessage', obj)
        return
      }

      this.isLoading = true
      // 食品情報の登録
      if (this.mode === 'free') {
        await this.sendFoodData()
      }

      // 飲食店情報の登録
      if (this.mode === 'shop_google') {
        await this.sendShopData()
      }

      // 編集でもgoogle place情報の場合は飲食店を登録する
      if (this.mode === 'edit' && this.karalogTarget.type === 'google') {
        await this.sendShopData()
      }
      
      let sendData = {}
      if (this.mode === 'edit') {
        sendData = this.makeFormObjEdit()
      } else if (this.mode === 'shop') {
        sendData = this.makeFormObjShop()
      } else if (this.mode === 'shop_google') {
        sendData = this.makeFormObjShop()
      } else {
        sendData = this.makeFormObj()
      }

      let imageCounter = this.UnUploadImageCount(this.imageData)
      let result = {}
      // 新規追加
      if (this.mode === 'edit') {
        result = await db.collection('post').doc(this.postId).set(sendData, {merge: true})
        this.id = this.postId
      } else {
        result = await db.collection('post').add(sendData)
        this.id = result.id
      }  
      this.$emit('onSendAccept', this.id)
      this.$store.commit('setTempPostId', this.id)

      if (imageCounter > 0) {
        // var storageRef = storage.ref()
        for (let i = 0; i < this.imageData.length; i++) {
          if (this.imageData[i] !== 'saved') {
            let imageRef = storageRef.child(`post/${this.id}/${sendData.images[i]}`)
            await imageRef.put(this.imageData[i])
            this.imageUploadedCounter++
            if (this.imageUploadedCounter === imageCounter) {
              //完了
              this.sendFin()
            }
          }
        }
      } else {
        // 完了
        this.sendFin()
      }
    },
    UnUploadImageCount (imageList) {
      let counter = 0
      imageList.forEach(i => {
        if (i !== 'saved') {
          counter++
        }
      })
      return counter
    },
    sendFin () {
      this.isLoading = false
      this.$emit('onSendFin', this.id)
    },
    makeFormObj () {
      let timestamp = new Date()
      let obj = {
        mode: this.mode,
        user: {
          uid: this.user.uid,
          displayName: this.user.displayName,
          imageurl: this.user.imageurl
        },
        timestamp_entry: timestamp,
        timestamp: timestamp,
        content: this.form.content,
        likes: []
      }

      if (this.mode !== 'noFood') {
        let food= {}
        food = {
          id: this.foodId,
          name: this.food.name
        }
        if (this.food.images[0]) {
          food.imageurl = this.food.images[0]
        }
        obj.food = food
      }

      if (this.isRating) {
        obj.rating = this.rating
      }

      if (this.isPlace) {
        obj.place = this.form.place
      }

      if (this.form.referURL !== '') {
        obj.referURL = this.form.referURL
      }

      let images = []
      let imageNameHead = String(timestamp.getTime())
      for (let i = 0; i < this.imageData.length; i++) {
        images.push(`${imageNameHead}_${i}.png`)
      }
      obj.images = images

      return obj
    },
    makeFormObjEdit () {
      let timestamp = new Date()
      let obj = {
        content: this.form.content,
        referURL: this.form.referURL,
        timestamp: timestamp
      }

      if (this.isPlace) {
        obj.place = this.form.place
      }
      if (this.isRating) {
        obj.rating = this.rating
      }

      let images = this.form.images
      let imageNameHead = String(timestamp.getTime())
      for (let i = 0; i < this.imageData.length; i++) {
        if (this.imageData[i] !== 'saved') {
          images.push(`${imageNameHead}_${i}.png`)
        }
      }
      obj.images = images

      if (this.karalogTarget.isChange) {
        if (this.karalogTarget.type === 'food') {
          obj.mode = 'food'
          obj.shop = {}
          let food= {}
          food = {
            id: this.foodId,
            name: this.food.name
          }
          if (this.food.images[0]) {
            food.imageurl = this.food.images[0]
          }
          obj.food = food
        } else if (this.karalogTarget.type === 'shop' || this.karalogTarget.type === 'google') {
          obj.mode = 'shop'
          obj.food = {}
          let shop= {}
          shop = {
            id: this.foodId,
            name: this.food.basic.name,
            address: this.makeAddress(this.food)
          }
          obj.shop = shop
        }
      }

      return obj
    },
    makeFormObjShop () {
      let timestamp = new Date()
      let obj = {
        mode: 'shop',
        user: {
          uid: this.user.uid,
          displayName: this.user.displayName,
          imageurl: this.user.imageurl
        },
        timestamp_entry: timestamp,
        timestamp: timestamp,
        content: this.form.content,
        likes: []
      }

      if (this.mode === 'shop' || this.mode == 'shop_google') {
        let shop= {}
        shop = {
          id: this.foodId,
          name: this.food.basic.name,
          address: this.makeAddress(this.food)
        }
        obj.shop = shop
      } 
      if (this.isRating) {
        obj.rating = this.rating
      }

      if (this.isPlace) {
        obj.place = this.form.place
      }

      if (this.form.referURL !== '') {
        obj.referURL = this.form.referURL
      }

      let images = []
      let imageNameHead = String(timestamp.getTime())
      for (let i = 0; i < this.imageData.length; i++) {
        images.push(`${imageNameHead}_${i}.png`)
      }
      obj.images = images

      return obj
    },
    makeAddress (obj) {
      if (obj.form) {
        if (obj.form.address.length > 10) {
          return obj.form.address
        }
      }
      if (obj.basic.address !== '') {
        return obj.basic.address
      }
      return ''
    },
    pickImage () {
      if (this.imageData.length >= 3) {
        let obj = {
          group: 'messageBottom',
          type: 'warning',
          title: '入力エラー',
          text: 'アップロードできる画像は3枚までです。'
        }
        this.$emit('onMessage', obj)
        return
      }
      this.$refs.image.click()
    },
    async onFileChange (e) {
      let files = e.target.files || e.dataTransfer.files

      var myFileType = files[0].type
      var fileTypeCheck = false
      for (var i = 0; i < fileExtensions.length; i++) {
        var fileExtension = fileExtensions[i]
        if (myFileType.indexOf(fileExtension) > -1) {
          fileTypeCheck = true
          break
        }
      }
      if (!fileTypeCheck) {
        let obj = {
          group: 'messageBottom',
          type: 'warning',
          title: '入力エラー',
          text: 'アップロードできるのは画像のみです。'
        }
        this.$emit('onMessage', obj)
        return
      }
      // const src = await imageResize.pFileReader(files[0])
      const src = await getBase64Strings(files, { maxSize: 1024 });
      this.imageURI.push(src)
      const img = await imageResize.pImage(src)
      const blob = await imageResize.resizeImage(img, maxSize, 'image/png')
      this.imageData.push(blob)
    },
    clearImage (id) {
      if (this.imageData[id] === 'saved') {
        storageRef.child(`post/${this.postId}/${this.form.images[id]}`).delete()
          .then(() => {
            let obj = {
              group: 'messageBottom',
              type: 'success',
              title: '画像を削除しました'
            }
            this.$emit('onMessage', obj)
          })
          .catch(error => {
            console.log(error)
          })
        this.form.images.splice(id, 1)
      }
      this.imageURI.splice(id, 1)
      this.imageData.splice(id, 1)
    },
    initEdit () {
      this.form.content = this.postData.content
      if (this.postData.referURL) this.form.referURL = this.postData.referURL

      if (this.postData.rating) {
        this.rating.hot = this.postData.rating.hot
        this.rating.taste = this.postData.rating.taste
      } else {
        this.isRating = false
      }

      if (this.postData.place) {
        this.form.place = this.postData.place
      } else {
        this.isPlace = false
      }
      for (let i = 0; i < this.postData.images.length; i++) {
        let path = this.postData.images[i]
        this.imageURI.push(getImageUrl.get('post', this.postId, path))
        this.imageData.push('saved')
      }
      this.form.images = this.postData.images
    },
    selectKaralogTarget(type) {
      this.karalogTarget.isChange = true
      this.karalogTarget.type = type
    }
  },
  components: {
  }
}
</script>
<style>
textarea {
  margin-top: 0 !important;
}
input {
  margin-top: 0 !important;
}
.formElementLabel {
  text-align: left;
  color:#888;
}
.formBlock {
  margin-bottom:24px;
}
.v-input__slot {
  margin-bottom:1px;
}
.v-input__slot {
  min-height:40px !important
}
</style>
